
export const CharactersHeader = () => {
  return (
    <div className="text-center space-y-4">
      <h1 className="text-4xl md:text-5xl font-bold text-teedee-blue">
        Meet Our Characters
      </h1>
      <p className="text-lg md:text-xl text-gray-600 max-w-3xl mx-auto">
        Discover the wonderful world of Bobo & Teedee and all their friends! 
        Each character brings their own unique personality and teaches valuable lessons 
        about Cayman Islands culture, friendship, and learning.
      </p>
    </div>
  );
};
